import React, {Component} from  'react';
import {connect} from 'react-redux';
// rest client
import {eapiClient, aemHostClient} from '../../../../restClient';
// utils
import {Translations} from '../../../../utils';
// constants
import {FORM_REFS} from '../../../../constants';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
// style
import './styles.css';

class CreateNewDeclarationSignatory extends Component{
  constructor(props) {
    super(props)
    this.state={}
  }

  componentWillMount(){
    let apiURL = "/aemData/formData/json_create-declaration-signatory";
    if(this.props.mode === "edit"){
      apiURL = apiURL.replace("create-", "edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      document.title = `${data.title} - ${'HSBC GLCM'}`;
      this.setState({formJson: data});
    });
  }

  getFormData = (formData) => {
    this.setState({formData});
  }

  onFormSubmit = (event, apiUrl) => {
    var requestData = {
      ...this.state.formData,
      caseId: this.props.currentCustomerDetails.data.caseId
    };
    requestData.entityId = this.props.currentCustomerDetails.data.id;

    if(this.props.mode === 'edit') {
      apiUrl = apiUrl + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(apiUrl, {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
    .then(({data, status}) => {
      var key = window.sessionStorage.getItem("getCurrentDropDown");
      window.sessionStorage.setItem('key'+ key, data.responseData.id);
      this.props.history.goBack();
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
    let formData;
    if(this.props.currentDeclarationSignatory !== undefined) {
      formData = {...this.props.currentDeclarationSignatory};
    }else {
      formData = {};
    }
    const properties = {
      contactId: this.props.match.params.contactId,
      contactType: this.props.match.params.contactType,
      formData,
      editType: 'create-new-declaration-signatory',
      pathname: this.props.history.location.pathname
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined){
      return (
        <Dynamicform mode={this.props.mode}
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
        getFormData={this.getFormData}
        history={this.props.history}
        match={this.props.match}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        lang={this.props.lang.currentLang.lang}
        translatedData={this.props.lang.translatedData}
        flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson['par'].page_title_mainTitle : '';
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">
        {Translations(pageTitle.pageHeading,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </h2>
      <p className="form-required-desc">
        {Translations(pageTitle.descriptionText,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentDeclarationSignatory = undefined;
  if(props.match.params) {
    var {contactId} = props.match.params;
    if(contactId && state.persons.length > 0){
      state.persons.forEach(declarationSignatory => {
        if(declarationSignatory.id === contactId) {
          currentDeclarationSignatory = declarationSignatory;
        }
      });
    }
  }
  return {
    currentDeclarationSignatory,
    mode: currentDeclarationSignatory !== undefined ? 'edit' : '',
    currentCustomerDetails: state.currentCustomerDetails,
    lang: state.lang
  };
}

export default connect(mapStateToProps)(CreateNewDeclarationSignatory);



// WEBPACK FOOTER //
// ./src/components/CaseBody/CustomerDetails/CaptureCustomerDetails/CreateNewDeclarationSignatory.js